import courseApi from "../../apis/courseApi"
import { getCoursesFail, getCoursesSuccess, isPending } from "./courseSlice"

export const fetchCoursesAction = (params) => async (dispatch) => {
  dispatch(isPending())
  const result = await courseApi.fetchAllCourses(params)
  if (result) {
    try {
      dispatch(getCoursesSuccess(result))
    } catch (error) {
      dispatch(getCoursesFail())
    }
  }
}
